import { render, staticRenderFns } from "./PinnaclesFlat.vue?vue&type=template&id=773fbc98&scoped=true&"
import script from "./PinnaclesFlat.vue?vue&type=script&lang=js&"
export * from "./PinnaclesFlat.vue?vue&type=script&lang=js&"
import style0 from "./PinnaclesFlat.vue?vue&type=style&index=0&id=773fbc98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773fbc98",
  null
  
)

export default component.exports